export function Logo({ size = "default" }: { size?: "default" | "sm" }) {
  const textSize = size === "sm" ? "text-[22px]" : "text-[26px]";
  const svgSize = size === "sm" ? 22 : 26;

  return (
    <span className={`flex items-center gap-1.5 ${textSize} font-black tracking-tighter text-primary font-display-xl`}>
      <svg
        width={svgSize}
        height={svgSize}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="moon-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#dfa6ff" />
            <stop offset="50%" stopColor="#ffcf8f" />
            <stop offset="100%" stopColor="#3e5eb5" />
          </linearGradient>
          {/* Mask cuts the right circle out cleanly — transparent, not white */}
          <mask id="moon-mask">
            <rect width="24" height="24" fill="white" />
            <circle cx="17" cy="12" r="8.5" fill="black" />
          </mask>
        </defs>

        {/* Crescent — gradient fill with transparent cutout */}
        <circle cx="12" cy="12" r="11" fill="url(#moon-grad)" mask="url(#moon-mask)" />
      </svg>
      Fluxrivet
    </span>
  );
}
